module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f000i-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An M1132 ESC of Alpha Troop, Regimental Engineer Squadron, 2nd Cavalry Regiment brings up a Mine Clearing Line Charge at the Grafenwoehr Training Area in March 2016. (US Army photo by Sgt. William Tanner)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47185c77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Fm.vue
// module id = 57
// module chunks = 0